import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

// Single `useBreakpoints` instance for the whole app, instantiated once at
// module load rather than per call site. Before this composable, the
// invoicing form tree independently re-created `useBreakpoints(breakpointsTailwind)`
// in `Form.vue`, `Form/Section.vue`, `Form/MobileSection.vue`, and — worse —
// inline inside a mitt listener in `useInvoiceForm.ts` (a fresh `matchMedia`
// instance on every `line:add` event, never disposed since there is no
// component scope to run its `onUnmounted` cleanup).
const breakpoints = useBreakpoints(breakpointsTailwind);

/**
 * The mobile/desktop boundary for the invoicing document form (`< 1024px`,
 * i.e. below Tailwind's `lg`). This is the ONLY place that boundary is
 * declared for that feature — do not re-instantiate `useBreakpoints` locally
 * for it.
 *
 * Scope: the invoicing document create/edit form and its overlay wrapper
 * (`ActionSheet`). Other parts of the app intentionally use a different
 * boundary (`md`, `xl`, or a hand-rolled `window.innerWidth` check) and must
 * not be migrated to this composable — see PROMPT.md §3.3.
 */
export const isMobileLayout = breakpoints.smaller('lg');

export function useIsMobileLayout() {
    return isMobileLayout;
}
